import { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const CapabilityCards = ({ cards }) => {
	const [activeIndex, setActiveIndex] = useState(0);

	const handleCardClick = (index) => {
		setActiveIndex(index);
	};

	const handleKeyDown = (e, index) => {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			setActiveIndex(index);
		}
	};

	const cardCount = cards?.length || 4;

	return (
		<Box
			className="card-container"
			sx={{ '--count': cardCount, '--gap': '5px', '--active-ratio': '0.6', '--desc-max-height': '200px' }}
		>
			{cards?.map((card, index) => {
				const isActive = index === activeIndex;
				const detailsId = `card-details-${index}`;
				return (
					<Box
						key={index}
						className={`card ${isActive ? 'active' : ''}`}
					>
						<Box
							className="card-toggle"
							onClick={() => handleCardClick(index)}
							onKeyDown={(e) => handleKeyDown(e, index)}
							tabIndex={isActive ? -1 : 0}
							role="button"
							aria-expanded={isActive}
							aria-controls={detailsId}
							aria-label={`${card.Title} — ${isActive ? 'expanded' : 'expand for details'}`}
						/>
						<img src={card.ImageURL} alt={card.ImageAltText} />
						<Box className="card-content">
							<Typography component="h3" variant="h6">{card.Title}</Typography>
							<Box
								id={detailsId}
								className="card-details"
								role="region"
								aria-label={`${card.Title} details`}
							>
								{card.Tags && card.Tags.length > 0 && (
									<ul>
										{card.Tags.map((tag, tagIndex) => (
											<li key={tagIndex}>{tag}</li>
										))}
									</ul>
								)}
								<p>
									{card.Description}
									{card.LinkURL && (
										<a href={card.LinkURL} tabIndex={isActive ? 0 : -1}>{card.LinkText || 'Learn More'}</a>
									)}
								</p>
							</Box>
						</Box>
					</Box>
				);
			})}
		</Box>
	);
};

export default CapabilityCards;
